import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./state/store";

import "./index.css";
import Layout from "./pages/layout/Layout";
import Seed from "./pages/seed/Seed";
import CaseletList from "./components/CaseletList/CaseletList";
import HomePage from "./pages/home_page/HomePage";
import ThoughtList from "./pages/thought_list/ThoughtList";
import Thoughts from "./pages/thoughts/Thoughts";
import SingleSeedInfo from "./pages/seed/SingleSeedInfo";
import ErrorBoundary from "./utils/ErrorBoundry";
import NoPage from "./pages/NoPage";
import UserLogin from "./pages/login/UserLogin";
import { Caselet } from "./pages/caselet/Caselet";
import UnpublishedCaseletList from "./components/CaseletList/UnpublishedCaseletList";
import Engagement from "./pages/engagment/Engagement";
import { ConfirmProvider } from "./utils/confirm/confirm.provider";
import MyExclusiveContentList from "./pages/my_exclusive_content/MyExclusiveContentList";
import ParticipantsManager from "./pages/add_partcipant/ParticipantsManager";
import AnalyticsTabs from "./pages/analytics/AnalyticsTabs";
import ActivityLogs from "./pages/analytics/ActivityLogs";
import LikeDislike from "./pages/analytics/LikeDislike";
import UnableToAnswer from "./pages/analytics/UnableToAnswer";
import PodcastsActivityLogs from "./pages/analytics/PodcastsActivityLogs";
import SourceWeights from "./pages/source_weights/SourceWeights";
import MyExclusiveDraftContent from "./pages/my_exclusive_content/MyExclusiveDraftContent";
import ShowPublishedContent from "./pages/my_exclusive_content/ShowPublishedContent";
import PodcastViewer from "./pages/podcast/PodcastViewer";
import BookViewer from "./pages/book/BookViewer";
import ContentManager from "./pages/content_manager/ContentManager";
import AdminRoute from "./pages/layout/AdminRoute";

let layout = <Layout />;

const router = createHashRouter([
    {
        path: "/",
        element: <>{layout}</>,

        children: [
            {
                path: "/",

                element: <HomePage />
            },
            {
                path: "/workbench",
                element: <HomePage />
            },
            {
                path: "/my-exclusive-content/new",
                element: <MyExclusiveDraftContent />
            },
            {
                path: "/my-exclusive-content/draft/:id",
                element: <MyExclusiveDraftContent />
            },
            {
                path: "/my-exclusive-content",
                element: <MyExclusiveContentList />
            },
            {
                path: "/my-exclusive-content/published/:id",
                element: <ShowPublishedContent />
            },
            {
                path: "/citation-explorer",
                element: <Seed />
            },
            {
                path: "/seeds/:seedId",
                element: <SingleSeedInfo />
            },
            {
                path: "/caselets",
                element: <CaseletList />
            },
            {
                path: "/unpublished-caselets",
                element: <UnpublishedCaseletList />
            },
            {
                path: "/seeds/:seedId/caselets",
                element: <CaseletList />
            },
            {
                path: "/caselets/:id",
                element: <Caselet />
            },
            {
                path: "/unpublished-caselets/:id",
                element: <Caselet />
            },
            {
                path: "/interaction/:Id",
                element: <Thoughts prompt={""} response={""} citations={""} />
            },
            {
                path: "/interactions",
                element: <ThoughtList />
            },
            // {
            //     path: "/engagement",
            //     element: <Engagement />
            // },
            {
                path: "/add-participant",
                element: <ParticipantsManager />
            },
            {
                path: "/analytics",
                element: <AnalyticsTabs />
            },
            {
                path: "/analytics/activity-log",
                element: <ActivityLogs />
            },
            {
                path: "/analytics/like-dislike",
                element: <LikeDislike></LikeDislike>
            },
            {
                path: "/analytics/unable-to-answer",
                element: <UnableToAnswer></UnableToAnswer>
            },
            {
                path: "/analytics/podcasts-activity-log",
                element: <PodcastsActivityLogs></PodcastsActivityLogs>
            },
            {
                path: "/source-weights",
                element: <SourceWeights></SourceWeights>
            },
            {
                path: "/content-upload",
                element: (
                    <AdminRoute>
                        <ContentManager />
                    </AdminRoute>
                )
            },
            {
                path: "/podcast/summary/:podcast_citation",
                element: <PodcastViewer></PodcastViewer>
            },
            {
                path: "/book/:book_name/:chapter_name",
                element: <BookViewer></BookViewer>
            },
            {
                path: "*",
                element: <NoPage />
            }
        ]
    },
    {
        path: "/user_login",
        element: <UserLogin />
    }
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <ErrorBoundary fallback="Error">
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ConfirmProvider>
                    <RouterProvider router={router} />
                </ConfirmProvider>
            </PersistGate>
        </Provider>
    </ErrorBoundary>
);
